import { Component, inject, input, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../../core/utils";
import type { ValueText } from "../../../models";
import { TagsApiService } from "../../../services";
import { FormDropdownComponent } from "../../form";

@Component({
  selector: "adaa-object-tags",
  imports: [TranslatePipe, FormsModule, NgbTypeaheadModule, FormDropdownComponent],
  styleUrl: "./styles.scss",
  template: `
    <section class="w-100 d-flex justify-content-between flex-wrap position-relative mt-2 p-2 object-tags shadow-sm">
      <div class="w-100 d-flex align-content-center object-tags--item">
        <span class="d-block w-50 fw-bold mb-2">
          {{ "plusbutton.tags" | translate }}
        </span>
      </div>

      <div class="w-100">
        <adaa-form-dropdown
          [clearable]="true"
          [options]="tags()"
          [setDefaultValue]="selectedTag()"
          (inputChanges)="setTag($event)"
        ></adaa-form-dropdown>
      </div>
    </section>
  `,
})
export class ObjectTagsComponent {
  private readonly _tagsApiService = inject(TagsApiService);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);

  id = input.required<number>();
  type = input.required<number>();
  itemType = input.required<number>();
  selectedTag = input<number>();
  tagId = signal<number | null>(null);

  tags = signal<ValueText[]>([]);

  public ngOnInit() {
    this._getKPIAvailableTags();
    this.tagId.set(this.selectedTag() ?? null);
  }

  private _getKPIAvailableTags() {
    return this._tagsApiService.getKPIAvailableTags().subscribe({
      next: (res) => {
        if (res.inError) return;
        this.tags.set(AdaaHelper.setDropdownArray(res.responseData, "id", AdaaHelper.getFieldLanguage("name")));
      },
    });
  }

  public setTag(event: number) {
    if (event) this.tagId.set(event);
    this._tagsApiService
      .updateTag(
        {
          ...(event ? { id: event } : {}),
          itemId: this.id(),
          itemTypeId: this.itemType(),
          tagId: event ?? this.tagId(),
        },
        !event
      )
      .subscribe({
        next: (res) => {
          if (res.inError) return;
          this._toastrService.success(this._translateService.instant("notification.success.save"));
        },
      });
  }
}
